module.exports = __webpack_public_path__ + "img/t2-1.8a0b4474.png";